export default function SvgDislove() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      cursor="pointer"
      viewBox="0 0 24 24"
    >
      <path d="M20.5 4.609A5.811 5.811 0 0016 2.5a5.75 5.75 0 00-4 1.455A5.75 5.75 0 008 2.5a5.811 5.811 0 00-4.5 2.109c-.953 1.156-1.95 3.249-1.289 6.66 1.055 5.447 8.966 9.917 9.3 10.1a1 1 0 00.974 0c.336-.187 8.247-4.657 9.3-10.1.665-3.411-.332-5.504-1.285-6.66zm-.674 6.28C19.08 14.74 13.658 18.322 12 19.34c-2.336-1.41-7.142-4.95-7.821-8.451-.513-2.646.189-4.183.869-5.007A3.819 3.819 0 018 4.5a3.493 3.493 0 013.115 1.469 1.005 1.005 0 001.76.011A3.489 3.489 0 0116 4.5a3.819 3.819 0 012.959 1.382c.678.824 1.38 2.361.867 5.007z"></path>
    </svg>
    </>
  );
}
